import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'tasks-icon',
  templateUrl: './tasks-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TasksIconComponent {}
